import React, { useContext, useState } from "react";
import NuevoProducto from "./NuevoProducto";
import ListadoProductos from "./ListadoProductos";
import "./ProductosAdmin.css";
import { Plus, Upload } from "lucide-react";
import ImportarProductos from "./ImportarProductos";
import Permiso from "../../router/Permiso";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const ProductosAdmin = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [tab, setTab] = useState("listado");
  const [mostrarImportar, setMostrarImportar] = useState(false);
  const [debeRecargar, setDebeRecargar] = useState(false);

  const renderTab = () => { 
    switch (tab) {
      case "nuevo":
        return <NuevoProducto token={token} />;
      case "listado":
        return <ListadoProductos token={token} debeRecargar={debeRecargar} 
          onRecargaCompleta={() => setDebeRecargar(false)} />;
      default:
        return null;
    }
  };

  const handleOpenNewProduct = () => {
    navigate("/admin/productos/registrar");
  };

  return (
    <div className="productos-admin-content">
      <div className="productos-admin-header">
        <div className="productos-admin-header-row">
          <div>
            <div className="productos-admin-title">Productos</div>
            <div className="productos-admin-subtitle">
              Gestión profesional de productos
            </div>
          </div>
          <div className="usuarios-admin-actions">
            <Permiso permiso="add_products">
              <button onClick={handleOpenNewProduct} className="btn-nuevo"> 
                <Plus size={18} style={{ marginRight: "6px" }} /> Nuevo Producto
              </button>
            </Permiso>
            <Permiso permiso="import_products">
              <button
                className="btn-nuevo-importar"
                onClick={() => setMostrarImportar(true)}
              >
                <Upload size={18} style={{ marginRight: "6px" }} />
                Importar
              </button>
              {mostrarImportar && (
                <ImportarProductos
                  onClose={() => setMostrarImportar(false)}
                  onSuccess={() => setDebeRecargar(true)}
                  token={token}
                />
              )}
            </Permiso> 
          </div>
        </div>
        <div className="productos-admin-tabs">
          <Permiso permiso="list_products">
            <button
              className={tab === "listado" ? "active" : ""}
              onClick={() => setTab("listado")}
            >
              Listado de Productos
            </button>
          </Permiso>
        </div>
      </div>
      <div className="productos-admin-tab-content">{renderTab()}</div>
    </div>
  );
};

export default ProductosAdmin;
